import React from 'react';
import { LegalDocument } from '../../components/sections/LegalDocument';
import { PageHero } from '../../components/ui/PageHero';
import { termsSections } from '../../data/legal';
import { usePageMeta } from '../../hooks/usePageMeta';
export function Terms() {
  usePageMeta('Terms of Use', 'The terms governing use of the Aurevane Search Partners website.');
  return <>
      <PageHero compact label="Legal" title="Terms of Use" intro="The terms that apply when you use this website." data-id="element-904" data-mp="3aoeqjwvpylzp" />
      <LegalDocument sections={termsSections} data-id="element-905" data-mp="3fnhwdjjiww8q" />
    </>;
}